module.exports = __webpack_public_path__ + "img/Deathknight-undead-m-70.3d22c3fc.gif";